import React from 'react';
import PropTypes from 'prop-types';
import css from './InputNumber.module.scss';

const InputNumber = ({
  label,
  inputMode = 'decimal',
  name,
  placeholder,
  value,
  onChange,
  error,
  invalid = false,
  min,
  max,
  step = 1,
  required = false,
  disabled = false,
  className = '',
  prefix,
  suffix,
  allowDecimals = true,
  labelPosition = 'top'
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;

    if (newValue === '') {
      onChange(e);
      return;
    }

    const isValidNumber = allowDecimals 
      ? /^-?\d*\.?\d*$/.test(newValue)
      : /^-?\d*$/.test(newValue);
    
    if (!isValidNumber) return;

    const numValue = parseFloat(newValue);
    if ((min !== undefined && numValue < min) || 
        (max !== undefined && numValue > max)) {
      return;
    }
    onChange(e);
  };

  return (
    <div className={`${css.inputContainer} ${className} ${css[`label-${labelPosition}`]}`}>
      {label && (
        <label className={css.label}>
          {label}
          {required && <span className={css.required}>*</span>}
        </label>
      )}
      <div className={css.inputWrapper}>
        {prefix && <span className={css.affix}>{prefix}</span>}
        <input
          type="number"
          inputMode={inputMode}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          min={min}
          max={max}
          name={name}
          step={step}
          className={`${css.input} ${(error || invalid) ? css.error : ''} ${prefix ? css.hasPrefix : ''} ${suffix ? css.hasSuffix : ''}`}
          data-error={!!(error || invalid)}
        />
        {suffix && <span className={`${css.affix} ${css.suffix}`}>{suffix}</span>}
      </div>
      {error && <span className={css.errorMessage}>{error}</span>}
    </div>
  );
};

InputNumber.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  invalid: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  allowDecimals: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['top', 'left']),
};

export default InputNumber;
